import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import AboutSection from '../AboutSection';

function AboutUs() {
    window.scrollTo(0,0);
    return(
        <>
            <AboutSection />
            <Footer/>
          
        </>
      );
}

export default AboutUs
